var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interface"},[_c('div',{staticClass:"interface__menu"},_vm._l((_vm.buttons),function(item,index){return _c('InterfaceButtons',{key:index,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }